import React from 'react';
import Navigation from '@/components/Navigation';
import FooterWithNewsletter from '@/components/ui/footer-column';
import TellAFriendForm from '@/components/TellAFriendForm';

const TellAFriendPage: React.FC = () => {
  return (
    <div className="min-h-screen">
      <Navigation />
      <div className="py-24 bg-gradient-hero-background relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-subtle opacity-30"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto">
            <div className="flex flex-col items-center text-center space-y-8">
              <div className="max-w-4xl">
                  <h2 className="text-4xl md:text-5xl font-bold mb-6 text-foreground">
                    Know Someone <br /> 
                   <span className='block mt-[10px]'> Who Might Be Interested?</span>
                  </h2>
                <div className="space-y-6 text-lg text-muted-foreground">
                  <p>
                    If gimmefy sounds like the secret weapon someone you know needs, why not share a special signup link with them. They'll receive additional FREE credits on a free plan.
                  </p>
                  <p>
                    Fill in their details below—because great marketing breakthroughs are even better when shared.
                  </p>
                </div>
              </div>
              <div className="w-full max-w-3xl mt-2">
                <TellAFriendForm />
              </div>
            </div>
          </div>
        </div>
      </div>
      <FooterWithNewsletter />
    </div>
  );
};

export default TellAFriendPage;
